
import { RecoveryPassword } from "../components/auth/login/RecoveryPassword.tsx";
import AuthLayoutWithReCaptcha from "../components/layouts/AuthLayoutWithReCaptcha.tsx";
import UtilsHelper from "../helpers/utilsHelper.ts";

const RecoverPasswordPage = () => {
    UtilsHelper.changeWindowDocumentTitle("Odzyskiwanie hasła");
    return (
        <AuthLayoutWithReCaptcha>
            <RecoveryPassword />
        </AuthLayoutWithReCaptcha>
    );
};

export default RecoverPasswordPage;